import { styled } from '@mui/material/styles';
import TableCell, { tableCellClasses } from '@mui/material/TableCell';
import { Dialog, Paper, TableRow, Typography } from '@mui/material';
import { GridOverlay } from '@mui/x-data-grid';
import PictureAsPdfOutlinedIcon from "@mui/icons-material/PictureAsPdfOutlined";
import ImageOutlinedIcon from "@mui/icons-material/ImageOutlined";
import InsertDriveFileOutlinedIcon from "@mui/icons-material/InsertDriveFileOutlined";
import DownloadOutlinedIcon from "@mui/icons-material/DownloadOutlined";
import DeleteOutlineOutlinedIcon from "@mui/icons-material/DeleteOutlineOutlined";


export default function NoDataFoundMessage() {
  return (
    <GridOverlay>
      <Typography variant="h6" color="textSecondary">
        No record found
      </Typography>
    </GridOverlay>
  );
}

export const formatValueWithDecimalPlaces = (value, decimalPlaces = 2, currency = false) => {
  if (value === '' || value == null) return '';

  const numericValue = Number(value);
  if (!Number.isFinite(numericValue)) return '';

  return new Intl.NumberFormat('en-CA', {
    ...(currency ? { style: 'currency', currency: 'CAD' } : {}),
    minimumFractionDigits: decimalPlaces,
    maximumFractionDigits: decimalPlaces
  }).format(numericValue);
};

export const limitDecimalPlaces = (value, decimalPlaces = 5) => {
  const [integerPart, ...fractionalParts] = String(value).split('.');
  if (fractionalParts.length === 0) return String(value);

  return `${integerPart}.${fractionalParts.join('').slice(0, decimalPlaces)}`;
};

export const formatDecimalValue = (value, decimalPlaces = 5) => {
  if (value === '' || value == null) return '';

  const numericValue = Number(value);
  return Number.isFinite(numericValue) ? numericValue.toFixed(decimalPlaces) : '';
};

export const formatAbsoluteEditingValue = (value, decimalPlaces = 5) =>
  value == null
    ? ''
    : limitDecimalPlaces(String(value).replace(/^[+-]/, ''), decimalPlaces);

export const AccountTypeData = [
  { label: 'All In One', value: 1 },
  { label: 'DAP', value: 6 },
  { label: 'TFSA', value: 7 },
  { label: 'RRSP', value: 8 },
  // { label: 'TFSA', value: 0 },
  { label: 'SpRRSP', value: 9 },
  { label: 'LIRA', value: 10 },
  { label: 'RRIF', value: 11 },
  { label: 'LIF', value: 13 },
  { label: 'LRSP', value: 20 },
  { label: 'Corporate Margin', value: 21 },
  { label: 'Individual Single RESP', value: 22 },
  { label: 'Individual Family RESP', value: 23 },
  { label: 'Joint Single RESP', value: 24 },
  { label: 'Joint Family RESP', value: 25 },
  { label: 'Joint Non-Registered', value: 26 }
];

export const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14
  },
  '&:nth-of-type(odd)': {
    backgroundColor: '#124734',
    color: theme.palette.common.white
  },
  '&:nth-of-type(even)': {
    backgroundColor: '#0e3a2a',
    color: theme.palette.common.white
  },
  // hide last border
  '&:last-child td, &:last-child th': {
    border: 0
  }
}));

export const StyledTableCellData = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.body}`]: {
    fontSize: 13
  },

  '&:nth-of-type(odd) ': {
    backgroundColor: '#efefef',
    color: '#2a2a2a'
  },
  '&:nth-of-type(even) td': {
    backgroundColor: '#f5f5f5',
    color: '#2a2a2a'
  },
  // hide last border
  '&:last-child td, &:last-child td': {
    border: 0
  }
}));

export const StyledTableRow = styled(TableRow)(({ theme }) => ({
  '&:nth-of-type(odd)': {
    backgroundColor: theme.palette.action.hover
  },
  '&:nth-of-type(even) td': {
    backgroundColor: '#f5f5f5',
    color: '#2a2a2a'
  },
  // hide last border
  '&:last-child td, &:last-child th': {
    border: 0
  }
}));


export const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  '& .MuiDialogContent-root': {
    padding: theme.spacing(2),
  },
  '& .MuiDialogActions-root': {
    padding: theme.spacing(1),
  },
}));

export const blockSpecialChar = (e) => {

  const { key } = e;

  const allowedPattern = /^[a-zA-Z0-9\s]+$/;

  if (!allowedPattern.test(key)) {
    e.preventDefault();
    return false;
  }
}


export const StyledTableCellSecond = styled(TableCell)(({ theme }) => ({

  [`&.${tableCellClasses.head}`]: {
    color: theme.palette.common.white
  },
  '&:nth-of-type(odd)': {
    padding: '3px 8px',
    minHeight: 100
  },
  '&:nth-of-type(even)': {
    padding: '3px 8px',
    minHeight: 100
  },
  [`&.${tableCellClasses.root}`]: {
    padding: '3px 8px',
    minWidth: 80,
    fontSize: 14,
    color: 'black'
  },
  '.css-rpurbm-MuiInputBase-input-MuiOutlinedInput-input.MuiInputBase-inputSizeSmall': {
    padding: '4px 11px'
  }
}));

export const  ActivityListItemWrapper = styled('div')(({ theme }) => ({
    // cursor: 'pointer',
    padding: 16,
    '&:hover': {
        background: theme.palette.primary.light
    },
    '& .MuiListItem-root': {
        padding: 0
    }
}));

export const WhiteContainer = styled(Paper)(({ theme }) => ({
  ...theme.typography.body2,
  padding: theme.spacing(2),
  // padding: '0',
  // textAlign: 'center',
  color: theme.palette.text.secondary,
}));

export const getStatusColor = (status) => {
  switch (status) {
    case 'Active':
      return 'success';
    case 'Pending':
      return 'warning';
    case 'Rejected':
      return 'error';
    default:
      return 'default';
  }
};

export const lightColors = [
  '#F2F4F8', // Light grayish blue
  '#E2F0CB', // Light pastel green
  '#F5E1DA', // Light peach
  '#D8E0F3', // Light sky blue
  '#F0E6F4', // Light lavender
  // '#FFFAE3', // Light yellow
  '#E0F7FA', // Light cyan
  '#F1F8E9', // Light green
  '#FFF3E0', // Light orange
  '#F3E5F5', // Light purple
  '#EDE7F6', // Light violet
  '#E1F5FE', // Light baby blue
  '#FFF8E1', // Light cream
  '#FCE4EC', // Light pink
  '#E8F5E9', // Light mint green
  '#FFEBEE', // Light rose
  '#F9FBE7', // Light lime
  '#E3F2FD', // Light azure
  '#E0F2F1', // Light teal
  // '#FFEB3B', // Light sunny yellow
];

export const getRandomColor = () => {
  return lightColors[Math.floor(Math.random() * lightColors.length)];
};


/* export const getRandomColor = () => {
  const letters = '0123456789ABCDEF';
  let color = '#';
  for (let i = 0; i < 6; i++) {
    color += letters[Math.floor(Math.random() * 16)];
  }
  return color;
}; */

export const formatDateDMY = (timestamp) => {
  const date = new Date(timestamp);
  return new Intl.DateTimeFormat('en-US', { year: 'numeric', month: 'long', day: 'numeric' }).format(date);
};

export const isZeroDateValue = (value) => {
  if (typeof value === 'string' && /^0000[-/]00[-/]00(?:$|T)/.test(value)) {
    return true;
  }

  return value instanceof Date && !Number.isNaN(value.getTime()) && value.getFullYear() === 0;
};

const getCalendarDate = (value) => {
  if (value instanceof Date) {
    if (Number.isNaN(value.getTime()) || value.getFullYear() < 1 || value.getFullYear() > 9999) {
      return null;
    }
    return new Date(value.getFullYear(), value.getMonth(), value.getDate());
  }

  if (typeof value !== 'string') {
    return null;
  }

  const normalizedValue = value.trim();
  const yearFirstDate = normalizedValue.match(/^(\d{4})[-/](\d{1,2})[-/](\d{1,2})(.*)$/);
  const monthFirstDate = normalizedValue.match(/^(\d{1,2})\/(\d{1,2})\/(\d{4})$/);
  const year = yearFirstDate ? Number(yearFirstDate[1]) : monthFirstDate ? Number(monthFirstDate[3]) : 0;
  const month = yearFirstDate ? Number(yearFirstDate[2]) : monthFirstDate ? Number(monthFirstDate[1]) : 0;
  const day = yearFirstDate ? Number(yearFirstDate[3]) : monthFirstDate ? Number(monthFirstDate[2]) : 0;

  if (year < 1 || year > 9999 || month < 1 || month > 12 || day < 1) {
    return null;
  }

  const date = new Date(0);
  date.setFullYear(year, month - 1, day);
  date.setHours(0, 0, 0, 0);

  if (date.getFullYear() !== year || date.getMonth() !== month - 1 || date.getDate() !== day) {
    return null;
  }

  if (yearFirstDate && yearFirstDate[4] && Number.isNaN(new Date(normalizedValue).getTime())) {
    return null;
  }

  return date;
};

export const isValidDateValue = (value) => {
  return value != null && value !== '' && !isZeroDateValue(value) && getCalendarDate(value) !== null;
};

export const validateDateValue = (value, options = {}) => {
  const { required = false, disableFuture = false, disablePast = false, minDate, maxDate } = options;
  const isEmpty = value == null || value === '' || isZeroDateValue(value);

  if (isEmpty) {
    return required ? 'Date is required.' : true;
  }

  const date = getCalendarDate(value);
  if (!date) {
    return 'Enter a valid date.';
  }

  const today = new Date();
  today.setHours(0, 0, 0, 0);
  if (disableFuture && date > today) {
    return 'Date cannot be in the future.';
  }
  if (disablePast && date < today) {
    return 'Date cannot be in the past.';
  }

  const minimum = minDate ? getCalendarDate(minDate) : null;
  if (minimum && date < minimum) {
    return 'Date is earlier than the allowed minimum.';
  }

  const maximum = maxDate ? getCalendarDate(maxDate) : null;
  if (maximum && date > maximum) {
    return 'Date is later than the allowed maximum.';
  }

  return true;
};

export const formatDateMonthYear = (dateString) => {
  const date = new Date(dateString);

  const day = date.getUTCDate();
  const month = date.toLocaleString('default', { month: 'long' });
  const year = date.getUTCFullYear();

  // Get the day suffix (st, nd, rd, th)
  const getDaySuffix = (day) => {
    if (day > 3 && day < 21) return 'th'; // 11th, 12th, 13th, etc.
    switch (day % 10) {
      case 1: return 'st';
      case 2: return 'nd';
      case 3: return 'rd';
      default: return 'th';
    }
  };

  const dayWithSuffix = `${day}${getDaySuffix(day)}`;

  return `${dayWithSuffix} ${month}-${year}`;
};

export const parentSteps = [
    {
        step: 0,
        permissions: [
            'Household Role',
            'Personal Information',
            'Address',
            'Financial',
            'Regulatory'
        ]
    },
    {
        step: 1,
        permissions: [
            'Account Type & Information',
            'Beneficiary Information',
            'Transfer Details',
            'Bank Information',
            'EFT Details',
            'PAC Details',
            'SWP Details',
            'Income Sweep'
        ]
    },
    {
        step: 2,
        permissions: [
            'Input',
            'Portfolio View',
            'Enhancements',
            'Notes',
            'Submit for Approval',
            'Save and Send to Manager'
        ]
    },
    {
        step: 3,
        permissions: ['Review']
    },
    {
        step: 4,
        permissions: ['Agreement']
    },
    {
        step: 5,
        permissions: ['Thank You']
    }
];

const storedPermissions = localStorage.getItem('manager_permissions');
const parsedPermissions = storedPermissions ? JSON.parse(storedPermissions) : {};
const hasPermission = (permissionName) => Object.prototype.hasOwnProperty.call(parsedPermissions, permissionName);

export const isStepAllowed = (step) => {
    const stepData = parentSteps.find(item => item.step === step);

    if (!stepData) {
        return false;
    }

    return stepData.permissions.some(permission =>
        hasPermission(permission)
    );
};

export const getNextAllowedStep = (currentStep) => {
    for (let step = currentStep + 1; step < parentSteps.length; step++) {
        if (isStepAllowed(step)) {
            return step;
        }
    }
    return currentStep;
};


export const getPreviousAllowedStep = (currentStep) => {
    for (let step = currentStep - 1; step >= 0; step--) {
        if (isStepAllowed(step)) {
            return step;
        }
    }

    return currentStep;
};


export const smallMenuItemSx = {
    width: '150px',
    '& .MuiInputBase-root': {
        height: '30px',
    },
    '& .MuiSelect-select': {
        minHeight: '30px !important',
        boxSizing: 'border-box',
        display: 'block',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
        lineHeight: '30px',
        py: '0 !important',
  }
}


export const formatFileSize = (bytes) => {
    if (!bytes) return "";
    return bytes < 1024 * 1024
        ? `${(bytes / 1024).toFixed(1)} KB`
        : `${(bytes / (1024 * 1024)).toFixed(2)} MB`;
};

export const getFileIcon = (fileName = "") => {
    const extension = fileName.split(".").pop()?.toLowerCase();

    if (extension === "pdf") {
        return <PictureAsPdfOutlinedIcon color="error" />;
    }

    if (["jpg", "jpeg", "png"].includes(extension)) {
        return <ImageOutlinedIcon color="primary" />;
    }

    return <InsertDriveFileOutlinedIcon />;

};
